<template>
  <v-row class="justify-end no-gutters">
    <loader v-if="contentLoading" />
    <x-button
      class="ml-2"
      color="#58E2C2"
      buttonText="Download"
      :data-test-id="`${dataTestId}__download-btn`"
      @click="downloadzip"
      v-if="canDownloadEmail && isSelected && hideBulk"
    />
    <x-button
      class="ml-2"
      color="#58E2C2"
      buttonText="Download"
      :data-test-id="`${dataTestId}__download-all-btn`"
      @click="downloadBulk"
      v-if="canDownloadEmail && isSelected && bulkDownload"
    />
    <!-- <x-button
      class="ml-2"
      color="#58E2C2"
      buttonText="Redeliver"
      v-if="isSelected"
      @click="chooseDataForRedeliver"
    /> -->

    <!-- <x-button
      class="ml-2"
      color="#58E2C2"
      buttonText="Mark as spam"
      v-if="isSelected && typeEmail === 'inbox'"
      @click="markSpam"
    />
    <x-button
      class="ml-2"
      color="#58E2C2"
      buttonText="Mark as safe"
      v-if="isSelected && typeEmail === 'spam'"
      @click="markInbox"
    /> -->
    <!-- <v-btn
      small
      tile
      color="#58e2c2"
      class="ml-2 white--text"
      @click="markInbox"
      v-if="typeEmail === 'spam'"
    >Mark as safe</v-btn>-->
  </v-row>
</template>

<script>
import store from '@/store';
import EventBus from '@/EventBus';
import DownloadService from '../../services/DownloadService';
import ArchiveService from '../../services/ArchiveService';
export default {
  store,
  data() {
    return {
      loading: false,
      downloadBtn: true,
      redeliverBtn: true,
      safeBtn: true,
      receiveData: [],
      contentLoading: false
    };
  },
  props: [
    'recipients',
    'archiveId',
    'isSelected',
    'archives',
    'hideBulk',
    'typeEmail',
    'bulkDownload',
    'primaryEmail',
    'individualType',
    'dataTestId',
    'canDownloadEmail'
  ],
  mounted() {
    EventBus.$on('REDELIVER_EMAIL', value => {
      let temp = this.encodeArchiveID();
      let data = this.getEmail(value);
      if (temp.length > 0 && data.length > 0) {
        let archives = [
          {
            archive: this.archiveId[0],
            recipients: data
          }
        ];
        this.redeliver(archives);
      }
    });
  },
  methods: {
    chooseDataForRedeliver() {
      let receipientData = [];
      if (this.individualType === 'Individual') {
        EventBus.$emit('SELECT_RECEIPIENT', this.recipients);
        return;
      } else {
        let temp = this.encodeArchiveID();
        let data = this.getEmail(this.recipients);
        if (data.length > 0) {
          receipientData = data;
        } else {
          receipientData = this.primaryEmail;
        }
        this.redeliver(temp, receipientData);
      }
    },
    downloadBulk() {
      this.downloadzip(this.archiveId);
    },
    encodeArchiveID() {
      let temp = [];
      this.archiveId.forEach(element => {
        temp.push(encodeURIComponent(element));
      });
      return temp;
    },
    getEmail(arr) {
      let temp = [];
      arr.forEach(element => {
        let index = element.indexOf('<');
        if (index > 0) {
          var mySubString = element.substring(
            element.lastIndexOf('<') + 1,
            element.lastIndexOf('>')
          );
          temp.push(mySubString);
        } else {
          temp.push(element);
        }
      });
      return temp;
    },
    async redeliver(archives) {
      this.$emit('eventChange', true);
      try {
        this.contentLoading = true;
        let response = await ArchiveService.reDeliver(
          this.archives.length ? this.archives : archives
        );
        if (response) {
          this.contentLoading = false;
          this.snackbar('info', this.$message.MAIL_REDELIVERED);
        }
      } catch (err) {
        this.contentLoading = false;
        this.snackbar('error', err);
      }
      this.$emit('eventChange', 'redeliver');
    },
    async markSpam() {
      this.$emit('eventChange', true);
      let archives = [
        {
          archive: this.archiveId[0],
          recipients: this.recipients
        }
      ];
      try {
        let response = await ArchiveService.markAsSpam(
          this.archives.length ? this.archives : archives
        );
        if (response) {
          this.snackbar('info', this.$message.MAIL_MARKED_SPAM);
        }
        EventBus.$emit('markedSpam', true);
      } catch (err) {
        this.snackbar('error', err);
      }
      this.$emit('eventChange', false);
    },

    async markInbox() {
      this.$emit('eventChange', true);
      let archives = [
        {
          archive: this.archiveId[0],
          recipients: this.recipients
        }
      ];
      try {
        let response = await ArchiveService.markAsInbox(
          this.archives.length ? this.archives : archives
        );
        if (response) {
          this.snackbar('info', this.$message.MAIL_MOVED_INBOX);
        }
        EventBus.$emit('movedInbox', true);
      } catch (err) {
        this.snackbar('error', err);
      }
      this.$emit('eventChange', false);
    },
    async downloadzip(archiveIds) {
      this.$emit('eventChange', true);
      this.contentLoading = true;
      let archiveId = this.$route.params.archiveId;
      const orgId = this.orgId;

      try {
        let response = await DownloadService.downloadEmail({
          archiveIds: archiveIds ? archiveIds : [archiveId],
          orgId
        });
        if (response) {
          if (archiveIds) {
            if (this.archiveId.length === 1) {
              DownloadService.downloadEMLFile(response);
            } else {
              DownloadService.downloadZipFile(response);
            }
          } else {
            DownloadService.downloadEMLFile(response);
          }
          this.contentLoading = false;
        } else {
          this.contentLoading = false;
          this.snackbar('error', this.$message.ERROR_DOWNLOADING_FILE);
        }
      } catch (err) {
        this.contentLoading = false;
        this.snackbar('error', err);
      }
      this.$emit('eventChange', false);
    }
  },
  beforeDestroy() {
    EventBus.$off('REDELIVER_EMAIL');
  }
};
</script>
